export const countriesTranslations: Record<string, string> = {
    ANDORRA: $localize`:@@country-andorra:Andorra`,
    ALBANIA: $localize`:@@country-albania:Albania`,
    ARGENTINA: $localize`:@@country-argentina:Argentina`,
    AUSTRIA: $localize`:@@country-austria:Austria`,
    AUSTRALIA: $localize`:@@country-australia:Australia`,
    ALAND_ISLANDS: $localize`:@@country-aland:Åland Islands`,
    BOSNIA_AND_HERZEGOVINA: $localize`:@@country-bosnia:Bosnia and Herzegovina`,
    BARBADOS: $localize`:@@country-barbados:Barbados`,
    BELGIUM: $localize`:@@country-belgium:Belgium`,
    BULGARIA: $localize`:@@country-bulgaria:Bulgaria`,
    BENIN: $localize`:@@country-benin:Benin`,
    BOLIVIA: $localize`:@@country-bolivia:Bolivia`,
    BRAZIL: $localize`:@@country-brazil:Brazil`,
    BAHAMAS: $localize`:@@country-bahamas:Bahamas`,
    BOTSWANA: $localize`:@@country-botswana:Botswana`,
    BELARUS: $localize`:@@country-belarus:Belarus`,
    BELIZE: $localize`:@@country-belize:Belize`,
    CANADA: $localize`:@@country-canada:Canada`,
    SWITZERLAND: $localize`:@@country-switzerland:Switzerland`,
    CHILE: $localize`:@@country-chile:Chile`,
    CHINA: $localize`:@@country-china:China`,
    COLOMBIA: $localize`:@@country-colombia:Colombia`,
    COSTA_RICA: $localize`:@@country-costa:Costa Rica`,
    CUBA: $localize`:@@country-cuba:Cuba`,
    CYPRUS: $localize`:@@country-cyprus:Cyprus`,
    CZECHIA: $localize`:@@country-czechia:Czechia`,
    GERMANY: $localize`:@@country-germany:Germany`,
    DENMARK: $localize`:@@country-denmark:Denmark`,
    DOMINICAN_REPUBLIC: $localize`:@@country-dominican:Dominican Republic`,
    ECUADOR: $localize`:@@country-ecuador:Ecuador`,
    ESTONIA: $localize`:@@country-estonia:Estonia`,
    EGYPT: $localize`:@@country-egypt:Egypt`,
    SPAIN: $localize`:@@country-spain:Spain`,
    FINLAND: $localize`:@@country-finland:Finland`,
    FAROE_ISLANDS: $localize`:@@country-faroe:Faroe Islands`,
    FRANCE: $localize`:@@country-france:France`,
    GABON: $localize`:@@country-gabon:Gabon`,
    UNITED_KINGDOM: $localize`:@@country-united:United Kingdom`,
    GRENADA: $localize`:@@country-grenada:Grenada`,
    GUERNSEY: $localize`:@@country-guernsey:Guernsey`,
    GIBRALTAR: $localize`:@@country-gibraltar:Gibraltar`,
    GREENLAND: $localize`:@@country-greenland:Greenland`,
    GAMBIA: $localize`:@@country-gambia:Gambia`,
    GREECE: $localize`:@@country-greece:Greece`,
    GUATEMALA: $localize`:@@country-guatemala:Guatemala`,
    GUYANA: $localize`:@@country-guyana:Guyana`,
    HONDURAS: $localize`:@@country-honduras:Honduras`,
    CROATIA: $localize`:@@country-croatia:Croatia`,
    HAITI: $localize`:@@country-haiti:Haiti`,
    HUNGARY: $localize`:@@country-hungary:Hungary`,
    INDONESIA: $localize`:@@country-indonesia:Indonesia`,
    IRELAND: $localize`:@@country-ireland:Ireland`,
    ISLE_OF_MAN: $localize`:@@country-isle:Isle of Man`,
    ICELAND: $localize`:@@country-iceland:Iceland`,
    ITALY: $localize`:@@country-italy:Italy`,
    JERSEY: $localize`:@@country-jersey:Jersey`,
    JAMAICA: $localize`:@@country-jamaica:Jamaica`,
    JAPAN: $localize`:@@country-japan:Japan`,
    SOUTH_KOREA: $localize`:@@country-south-korea:South Korea`,
    LIECHTENSTEIN: $localize`:@@country-liechtenstein:Liechtenstein`,
    LESOTHO: $localize`:@@country-lesotho:Lesotho`,
    LITHUANIA: $localize`:@@country-lithuania:Lithuania`,
    LUXEMBOURG: $localize`:@@country-luxembourg:Luxembourg`,
    LATVIA: $localize`:@@country-latvia:Latvia`,
    MOROCCO: $localize`:@@country-morocco:Morocco`,
    MONACO: $localize`:@@country-monaco:Monaco`,
    MOLDOVA: $localize`:@@country-moldova:Moldova`,
    MONTENEGRO: $localize`:@@country-montenegro:Montenegro`,
    MADAGASCAR: $localize`:@@country-madagascar:Madagascar`,
    NORTH_MACEDONIA: $localize`:@@country-north-macedonia:North Macedonia`,
    MONGOLIA: $localize`:@@country-mongolia:Mongolia`,
    MONTSERRAT: $localize`:@@country-montserrat:Montserrat`,
    MALTA: $localize`:@@country-malta:Malta`,
    MEXICO: $localize`:@@country-mexico:Mexico`,
    MOZAMBIQUE: $localize`:@@country-mozambique:Mozambique`,
    NAMIBIA: $localize`:@@country-namibia:Namibia`,
    NIGER: $localize`:@@country-niger:Niger`,
    NIGERIA: $localize`:@@country-nigeria:Nigeria`,
    NICARAGUA: $localize`:@@country-nicaragua:Nicaragua`,
    NETHERLANDS: $localize`:@@country-netherlands:Netherlands`,
    NORWAY: $localize`:@@country-norway:Norway`,
    NEW_ZEALAND: $localize`:@@country-new-zealand:New Zealand`,
    PANAMA: $localize`:@@country-panama:Panama`,
    PERU: $localize`:@@country-peru:Peru`,
    PAPUA_NEW_GUINEA: $localize`:@@country-papua:Papua New Guinea`,
    POLAND: $localize`:@@country-poland:Poland`,
    PUERTO_RICO: $localize`:@@country-puerto:Puerto Rico`,
    PORTUGAL: $localize`:@@country-portugal:Portugal`,
    PARAGUAY: $localize`:@@country-paraguay:Paraguay`,
    ROMANIA: $localize`:@@country-romania:Romania`,
    SERBIA: $localize`:@@country-serbia:Serbia`,
    RUSSIA: $localize`:@@country-russia:Russia`,
    SWEDEN: $localize`:@@country-sweden:Sweden`,
    SINGAPORE: $localize`:@@country-singapore:Singapore`,
    SLOVENIA: $localize`:@@country-slovenia:Slovenia`,
    SVALBARD_AND_JAN_MAYEN: $localize`:@@country-svalbard:Svalbard and Jan Mayen`,
    SLOVAKIA: $localize`:@@country-slovakia:Slovakia`,
    SAN_MARINO: $localize`:@@country-san-marino:San Marino`,
    SURINAME: $localize`:@@country-suriname:Suriname`,
    EL_SALVADOR: $localize`:@@country-el-salvador:El Salvador`,
    TUNISIA: $localize`:@@country-tunisia:Tunisia`,
    TURKEY: $localize`:@@country-turkey:Turkey`,
    UKRAINE: $localize`:@@country-ukraine:Ukraine`,
    UNITED_STATES: $localize`:@@country-united-states:United States`,
    URUGUAY: $localize`:@@country-uruguay:Uruguay`,
    VATICAN_CITY: $localize`:@@country-vatican:Vatican City`,
    VENEZUELA: $localize`:@@country-venezuela:Venezuela`,
    VIETNAM: $localize`:@@country-vietnam:Vietnam`,
    SOUTH_AFRICA: $localize`:@@country-south-africa:South Africa`,
    ZIMBABWE: $localize`:@@country-zimbabwe:Zimbabwe`,
};
